import {
  Button as ButtonAntd,
  Card as CardAntd,
  Popover as PopoverAntd,
} from 'antd';
import styled from 'styled-components';

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding-top: 0;
  }

  .height-85 {
    height: 85vh;
  }

  .margin-0 {
    margin: 0;
  }

  .margin-divider {
    margin: 50px 0 50px;
  }

  .margin-bottom {
    margin-bottom: 35px;
  }
`;

export const Popover = styled(PopoverAntd)`
  float: right;
  color: #0d3549 !important;
  padding: 0px;
`;

export const ButtonBack = styled(ButtonAntd)`
  margin-right: 8px;
  background: #fff;
  border: #fff;
  color: #1890ff;
  font-weight: 700;

  :hover {
    color: #1890ff;
    background: #fff;
    border-color: #fff;
  }
`;

export const WrapperSpin = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
`;
